export default __webpack_public_path__ + "static/media/logo-color.bfa7948e.svg";